import { MockedRequest, RequestHandler, rest, restContext } from 'msw';
import * as fs from 'fs';
import * as path from 'path';

const handlers: RequestHandler<MockedRequest, typeof restContext>[] = [
  rest.get('/api/resource/documents/:id/content', (req, res, ctx) => {
    const documentBuffer = fs.readFileSync(
      path.resolve(__dirname, '../fixtures/E-Verify_Participation_Poster_Somali.pdf'),
    );
    return res(
      ctx.set('Content-Length', documentBuffer.byteLength.toString()),
      ctx.set('Content-Type', 'application/pdf'),
      ctx.set('Content-Disposition', 'attachment; filename="E-Verify_Participation_Poster_Somali.pdf"'),
      ctx.body(documentBuffer),
    );
  }),
];

export default handlers;
